// const ONEBYONE_BACKEND_API_ENDPOINT = "https://api.1byonehealth.com";
const ONEBYONE_BACKEND_API_ENDPOINT = "https://api.1byonehealth.com/api";
// const ONEBYONE_BACKEND_API_ENDPOINT = "http://api.1byonehealth.com";
// const ONEBYONE_BACKEND_API_ENDPOINT = "http://localhost:5000";
// const ONEBYONE_BACKEND_API_ENDPOINT = "https:// 120.77.215.164:5000";
export const defaultAxiosConfig = {
  baseURL: ONEBYONE_BACKEND_API_ENDPOINT,
  timeout: 20000
};
